// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"be506647","339":"74e5748e","617":"688a42ee","640":"11126420","821":"b677a17f"}[chunkId] + ".chunk.js";
};